import { CodeXml, Globe, Palette, ReceiptText, SlidersHorizontal } from '@lucide/vue'
import type { Component } from 'vue'

export interface NavItem {
  label: string
  to: string
  icon: Component
}

export const NAV_MAIN: NavItem[] = [{ label: 'Payments', to: '/payments', icon: ReceiptText }]

export const NAV_SETUP: NavItem[] = [
  { label: 'Design', to: '/design', icon: Palette },
  { label: 'Checkout settings', to: '/checkout', icon: SlidersHorizontal },
  { label: 'Developers', to: '/developers', icon: CodeXml },
  { label: 'Domains', to: '/domains', icon: Globe },
]

export const isActive = (item: NavItem, path: string) => path === item.to || path.startsWith(`${item.to}/`)
